var RemovedSportsModifier = /** @class */ (function () {
    function RemovedSportsModifier(modelKeyRepository) {
        this._modelKeyRepository = modelKeyRepository;
    }
    RemovedSportsModifier.prototype.modify = function (content) {
        if (content.sports === undefined) {
            return;
        }
        var sports = content.sports.remove;
        if (sports !== undefined) {
            for (var i = 0; i < sports.length; i++) {
                this._modelKeyRepository.removeSport(sports[i]);
            }
        }
    };
    return RemovedSportsModifier;
}());
export default RemovedSportsModifier;



// WEBPACK FOOTER //
// ./src/repositories/modifier/RemovedSportsModifier.js